import { DocumentDragKey } from "../../models/document/document-types";
export class ImageDragDrop {
    constructor(options) {
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.options = options;
    }
    dragOver(e) {
        // the cypress tests generate drag events without the dataTransfer element of the event
        if (this.hasMissingDataTransfer(e)) {
            return false;
        }
        const isAcceptableDrag = this.checkForAcceptableImageDrag(e);
        if (isAcceptableDrag) {
            e.dataTransfer.dropEffect = "copy";
            e.preventDefault();
            return true;
        }
        return false;
    }
    drop(e) {
        return new Promise((resolve, reject) => {
            // the cypress tests generate drag events without the dataTransfer element of the event
            if (this.hasMissingDataTransfer(e)) {
                return;
            }
            if (this.checkForAcceptableImageDrag(e)) {
                e.preventDefault();
                e.stopPropagation();
                if (this.hasUriList(e)) {
                    const uriList = e.dataTransfer.getData("text/uri-list");
                    const uriArray = uriList && uriList.split(/[\r\n]+/);
                    const dropUrl = uriArray && uriArray[0];
                    if (dropUrl) {
                        resolve(dropUrl);
                    }
                    else {
                        reject("No url found for dropped image");
                    }
                }
                else if (this.hasFileList(e)) {
                    const file = e.dataTransfer.files[0];
                    if (file) {
                        if (/^image\//.test(file.type)) {
                            const reader = new FileReader();
                            reader.onload = (readerEvent) => {
                                const dropUrl = readerEvent.target && readerEvent.target.result;
                                if (dropUrl) {
                                    resolve(dropUrl.toString());
                                }
                                else {
                                    reject("No url found for dropped image file");
                                }
                            };
                            reader.onerror = () => {
                                reject("Unable to read dropped image file");
                                reader.abort();
                            };
                            reader.readAsDataURL(file);
                        }
                        else {
                            reject("Only image files are allowed to be dropped");
                        }
                    }
                    else {
                        reject("No file found for dropped image");
                    }
                }
            }
            else {
                const isInternalDrag = !!e.dataTransfer.types.find((type) => /org\.concord\.clue\./.test(DocumentDragKey));
                if (!isInternalDrag) {
                    reject("Only images are allowed to be dropped");
                }
            }
        });
    }
    checkForAcceptableImageDrag(e) {
        const acceptableByClient = !this.options.isAcceptableImageDrag || this.options.isAcceptableImageDrag(e);
        return (this.hasUriList(e) || this.hasFileList(e)) && acceptableByClient;
    }
    hasUriList(e) {
        return e.dataTransfer.types.indexOf("text/uri-list") >= 0;
    }
    hasFileList(e) {
        return e.dataTransfer.types.indexOf("Files") >= 0;
    }
    hasMissingDataTransfer(e) {
        return !e.dataTransfer;
    }
}
//# sourceMappingURL=data:application/json;base64,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